// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1GFW3","colBig":"styles_colBig__Il9lr","colSmall":"styles_colSmall__38BXY","shopifyNameWrapper":"styles_shopifyNameWrapper__YuVRK"};